import MarketReportsMenu from '@/components/MarketReports/MarketReportsMenu.vue';

export default {
  components: {
    MarketReportsMenu
  },
  props: {
    header:       { type: String,   required: true },
    isEditable:   { type: Boolean,  required: true }
  },

  data() {
    return {
      valueAxis: [0, 100],
      scrollBar: {
        color: `var(--color-accent)`,
        enabled: true,
        offset: 2,
        position: `bottom`,
        range: undefined,
        width: 8
      },
      range: undefined
    };
  },
  
  methods: {
    handleEdit() {
      this.$emit('edit');
    },
    handleUndo() {
      this.$emit('undo');
    },
    handleSave() {
      this.$emit('save');
    },

    formatAsPercent(arg) {
      return arg.valueText + '%';
    }
  }
};
